module.exports = __webpack_public_path__ + "static/media/IMG_5799.5e414688.JPG";